document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('[data-lb-filters-drawer]');
  const openBtn = document.querySelector('[data-lb-filters-open]');

  if (!drawer || !openBtn) return;

  const closeBtns = drawer.querySelectorAll('[data-lb-filters-close]');
  const form = drawer.querySelector('form');

  let lastFocused = null;
  let isOpen = false;
  let openTimer = null;
  let closeTimer = null;

  const lockScroll = () => {
    document.documentElement.classList.add('lb-filters-lock');
    document.body.classList.add('lb-filters-lock');
  };

  const unlockScroll = () => {
    document.documentElement.classList.remove('lb-filters-lock');
    document.body.classList.remove('lb-filters-lock');
  };

  const clearTimers = () => {
    if (openTimer) {
      clearTimeout(openTimer);
      openTimer = null;
    }
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
  };

  const openDrawer = () => {
    if (isOpen) return;

    clearTimers();
    isOpen = true;
    lastFocused = document.activeElement;

    lockScroll();

    drawer.classList.add('is-visible');
    drawer.classList.add('is-blurring');

    // даем blur стартануть первым
    openTimer = setTimeout(() => {
      drawer.classList.add('is-panel-visible');
    }, 60);
  };

  const closeDrawer = () => {
    if (!isOpen) return;

    clearTimers();
    isOpen = false;

    drawer.classList.remove('is-panel-visible');

    closeTimer = setTimeout(() => {
      drawer.classList.remove('is-blurring');

      setTimeout(() => {
        drawer.classList.remove('is-visible');
        unlockScroll();

        if (lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus();
        }
      }, 120);
    }, 170);
  };

  openBtn.addEventListener('click', openDrawer);

  closeBtns.forEach((btn) => {
    btn.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isOpen) {
      closeDrawer();
    }
  });

  if (form) {
    form.addEventListener('submit', () => {
      closeDrawer();
    });
  }
});